<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView">
        <v-card class="mt-3 pa-1">
            <Title title="農薬使用状況">
                <v-spacer />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                            <v-text-field
                                v-model="conditionItems.year"
                                outlined
                                hide-details
                                dense
                                readonly
                                label="対象の年"
                                suffix="年"
                                prepend-icon="mdi-chevron-left-circle"
                                :append-outer-icon="conditionItems.year < maxYear ? 'mdi-chevron-right-circle' : null"
                                @click:prepend="conditionItems.year--"
                                @click:append-outer="conditionItems.year++" />
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                            <v-select
                                dense
                                v-model="conditionItems.month" 
                                label="対象の月" 
                                outlined 
                                hide-details
                                :items="months" 
                                clearable
                                :suffix="conditionItems.month != null ? '月' : ''" />
                        </v-col>
                        <v-col>
                            <v-checkbox
                                v-model="conditionItems.oderByUseNum"
                                label="使用回数順に並べる"
                                hide-details
                                dense />
                        </v-col>
                    </v-row>
                    <v-divider />
                    <v-row v-if="conditionItems.month != null" dense>
                        <v-col>
                            <v-sheet label color="cyan white--text" class="text-center pa-1" rounded>月が指定されている時は、制限回数は表示されません。</v-sheet>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-btn color="primary" @click="onClickOutputCSV" class="ma-1">
                                <v-icon>mdi-file-document-outline</v-icon>
                                CSV出力
                            </v-btn>
                            <v-btn color="primary" @click="onClickReport0001001" class="ma-1">
                                <v-icon>mdi-file-document-outline</v-icon>
                                栽培日誌作成(Excelファイル)
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-divider />
                            <v-simple-table v-if="!$vuetify.breakpoint.xs">
                                <thead>
                                    <tr>
                                        <th>農薬名</th>
                                        <th style="text-align:center">
                                            <span v-if="conditionItems.month == null">使用回数/制限</span>
                                            <span v-else>使用回数</span>
                                        </th>
                                        <template v-if="maxUsedDateNum > 0">
                                            <th style="text-align:center" v-for="tempHeaderCell in maxUsedDateNum" :key="tempHeaderCell">使用日<br/>散布量/希釈倍率</th>
                                        </template>
                                        <template v-else>
                                            <th style="text-align:center">使用日<br/>散布量/希釈倍率</th>
                                        </template>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="data in list" :key="data.agrichemical.agrichemicalNo">
                                        <td>
                                            {{data.agrichemical.name}}
                                        </td>
                                        <td style="text-align:center">
                                            {{agrichemicalUsedNum(data)}}
                                        </td>
                                        <template v-if="maxUsedDateNum > 0">
                                            <td v-for="(history, index) in data.histories" :key="index" style="text-align:center">
                                                <!-- <v-btn @click.stop="onClickHistoryData(data, history)" elevation="0" color="transparent light-blue--text">
                                                    {{history.body.date}}<br/>
                                                    {{history.prevatication}}L / {{history.dilution}}
                                                </v-btn> -->
                                                {{history.body.date}}<br/>
                                                {{history.prevatication}}L / {{history.dilution}}
                                            </td>
                                            <template v-if="data.histories.length < maxUsedDateNum">
                                                <td v-for="tempCell in maxUsedDateNum - data.histories.length" :key="tempCell" style="text-align:center">
                                                    ---
                                                </td>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <td style="text-align:center">---</td>
                                        </template>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <v-simple-table v-else>
                                <tr v-for="data in list" :key="data.agrichemical.agrichemicalNo">
                                    <td>
                                        <v-card class="ma-1">
                                            <v-card-text>
                                                <span class="font-weight-bold">{{data.agrichemical.name}}</span>
                                                <br/>
                                                <v-divider />
                                                使用回数:{{data.histories.length}}
                                                <span v-if="conditionItems.month == null"> / 制限:{{data.agrichemical.useLimitNum == 0 ? "" : data.agrichemical.useLimitNum}}</span>
                                                <template v-if="data.histories.length > 0">
                                                    <br/>
                                                    <table style="width:100%; text-align:center" class="caption">
                                                        <tr>
                                                            <td>使用日</td>
                                                            <td>散布量</td>
                                                            <td>希釈倍率</td>
                                                        </tr>
                                                        <tr v-for="(history, index) in data.histories" :key="index">
                                                            <td>{{history.body.date}}</td>
                                                            <td>{{history.prevatication}}L</td>
                                                            <td>{{history.dilution}}</td>
                                                        </tr>
                                                    </table>
                                                </template>
                                            </v-card-text>
                                        </v-card>
                                    </td>
                                </tr>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <WorkRecorder
            ref="workRecorder" />
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }
    Date.prototype.addDay = function (v) {
        this.setDate(this.getDate()+v)
        return this
    }
    Date.prototype.addMonth = function (v) {
        this.setMonth(this.getMonth()+1)
        return this
    }
    Date.prototype.diffMonth = function (d) {
        return (this.getFullYear() * 12 + this.getMonth()) - (d.getFullYear() * 12 + d.getMonth())
    }

    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import WorkRecorder from '@/components/place/RecorderPlaceWork'
    import Confirm from '@/components/tools/ConfirmDialog';

    export default {
        components: {
            Confirm,
            Title,
            TitleButton,
            WorkRecorder
        },
        data: function () {
            return {
                isView: false,
                /** 対象場所 */
                targetPlace: null,
                /** 対象農薬 */
                targetAgrichemical: null,
                /** 一覧に表示する全データを格納する配列 */
                list: [],
                /** 1つの農薬で最も使用日数の多かった農薬の使用日数 */
                maxUsedDateNum: 0,
                /** 最大年 */
                maxYear: 0,
                /** 表示条件項目 */
                conditionItems: {
                    year: 2020,
                    month: null,
                    oderByUseNum: false
                },
                /** 月のセレクター用選択項目 */
                months: [1,2,3,4,5,6,7,8,9,10,11,12],
                // レポート作成のサービス
                reportCreator: null,
                // レポート作成中は True
                isReportCreating: false
            }
        },
        computed: {
        },
        watch: {
            /** 表示条件の監視 */
            conditionItems: {
                handler: function (value, old) {
                    this.refresh()
                },
                deep: true
            },
            /** レポート作成の監視 */
            isReportCreating: function (value, old) {
                if (value) {
                    this.$store.commit
                    (
                        "processing", 
                        {
                            start:true, 
                            message:"レポートの作成中です。"
                        }
                    )
                } else {
                    this.$store.commit("processing")
                }
            }
        },
        methods: {
            // /**
            //  * 一覧の履歴押下時
            //  */
            // onClickHistoryData: function (data, history) {
            //     const placeData = this.$store.getters["managementItems/loggedInUserPlaceData"]
            //     const workTypes = placeData.workTypes
            //     this.$refs.workRecorder.show(this.targetPlace, workTypes, history.work, history.record)
            // },
            onClickReport0001001: function () {
                const self = this

                const request = {
                    userUID: this.$store.getters["userUID"],
                    reportID: "0001-001",
                    data: []
                }
                for (var i=0; i<this.list.length; i++) {
                    const data = {
                        agrichemical: this.list[i].agrichemical,
                        histories: []
                    }
                    request.data.push(data)
                    for (var j=0; j<this.list[i].histories.length; j++) {
                        data.histories.push(
                            {
                                history: this.list[i].histories[j].body,
                                prevatication: this.list[i].histories[j].prevatication,
                                dilution: this.list[i].histories[j].prevatication
                            }
                        )
                    }
                }
                this.reportCreator = new WebSocket("wss://service.tomson.xyz/myfield_report_creator")
                // this.reportCreator = new WebSocket("ws://localhost:9001")
                this.reportCreator.onopen = function (e) {
                    self.isReportCreating = true
                    self.reportCreator.send(
                        JSON.stringify(request)
                    )
                }
                this.reportCreator.onmessage = function (e) {
                    self.reportCreator.close()
                    const link = document.createElement("a")
                    link.href = e.data
                    link.download = "栽培日誌"
                    link.click()
                }
                this.reportCreator.onclose = function (e) {
                    console.log("onclose", e)
                    self.isReportCreating = false
                    // if (self.connected) {
                    //     self.setState("disconnect_wait_reconnect")
                    //     self.reconnectTimerID = setTimeout(function(){
                    //         self.connectServer()
                    //     }, 5000)
                    // }
                }
                this.reportCreator.onerror = function (e) {
                    console.log("onerror", e)
                    self.$refs.confirm.show({
                        title: "栽培日誌の作成失敗",
                        message: "栽培日誌の作成に出来ませんでした。<br/>サーバーのサービスがダウンしている可能性があります。<br/>少し時間をおいて、再度試してみて下さい。",
                        width: 400,
                        buttonYes: "戻る",
                        buttonNo: "",
                    })
                    return
                }
            },
            /**
             * CSV出力ボタン押下時
             */
            onClickOutputCSV: function () {
                var outputText = ""
                var header = "\ufeff" + "農薬名,使用回数"
                if (this.conditionItems.month == null) {
                    header+=",制限回数"
                }
                for (var i=1; i<=this.maxUsedDateNum; i++) {
                    header += ",使用日,散布量,希釈倍率"
                }
                outputText = header + "\n"
                for (var i=0; i<this.list.length; i++) {
                    const values = [
                        this.list[i].agrichemical.name,
                        this.list[i].histories.length,
                    ]
                    if (this.conditionItems.month == null) {
                        values.push(this.list[i].agrichemical.useLimitNum == 0 ? "" : this.list[i].agrichemical.useLimitNum)
                    }
                    for (var j=0; j<this.list[i].histories.length; j++) {
                        values.push(this.list[i].histories[j].body.date)
                        values.push(this.list[i].histories[j].prevatication)
                        values.push(this.list[i].histories[j].dilution)
                    }
                    const record = values.join(",")
                    outputText += (record + "\n")
                }
                
                const blob = new Blob([outputText], {type: "text/csv"})
                const link = document.createElement("a")
                link.href = window.URL.createObjectURL(blob)
                link.download = "agrichemical_history_" + this.targetPlace.body.name + "_" + this.conditionItems.year + (this.conditionItems.month != null ? "_"+this.conditionItems.month : "") + ".csv"
                link.click()
            },
            /**
             * 指定された農薬の一覧に表示する回数を返す
             */
            agrichemicalUsedNum: function (item) {
                
                const usedNum = item.histories.length

                if (this.conditionItems.month != null) {
                    return usedNum
                }

                const useLimitNum = item.agrichemical.useLimitNum == 0 ? "" : " / " + item.agrichemical.useLimitNum
                return usedNum + useLimitNum
            },
            /**
             * 表示条件に従って、一覧を更新
             */
            refresh: function () {

                console.log("refresh")

                // const condition = {
                //     targetYear: 年
                // }

                const self = this

                // 回数を管理する日付の範囲、もしくは指定された年月の範囲を算出
                var startDate = null
                var endDate = null

                if (this.conditionItems.month == null) {
                    startDate = new Date(this.conditionItems.year, this.targetPlace.body.managementAgrichemical.startDate.month - 1, this.targetPlace.body.managementAgrichemical.startDate.day)
                    endDate = (new Date(this.conditionItems.year+1, startDate.getMonth(), startDate.getDate())).addDay(-1)
                } else {
                    startDate = new Date(this.conditionItems.year, this.conditionItems.month-1, 1)
                    endDate = new Date(startDate.getTime())
                    endDate = endDate.addMonth(1).addDay(-1)
                }
                
                const startDateText = startDate.toFormatString("yyyy-MM-dd")
                const endDateText = endDate.toFormatString("yyyy-MM-dd")

                console.log(startDateText, endDateText)

                // 一覧に表示するデータの作成
                this.list = []

                for (var key in this.agrichemical.items) {

                    const chemical = this.agrichemical.items[key]

                    const listItem = {
                        agrichemical: chemical,
                        histories: [],
                    }
                    self.list.push(listItem)

                    const history = this.targetPlace.agrichemicalsHistory.agrichemicals[chemical.agrichemicalNo]
                    if (history != null) {
                        const itemHistories = history.histories.filter((v)=>v.date >= startDateText && v.date <= endDateText)
                        if (itemHistories.length > 0) {
                            itemHistories.forEach(function(itemHistory){
                                const historyData = {
                                    body: itemHistory,
                                    work: null,
                                    record: null,
                                    dilution: 0,        // 希釈倍率
                                    prevatication: 0    // 散布量
                                }
                                listItem.histories.push(historyData)
                                const targetWork = self.targetPlace.works.find((v)=>v.workID == itemHistory.workID)
                                if (targetWork != null) {
                                    historyData.work = targetWork
                                    const record = targetWork.records.find((v)=>v.dateTime == itemHistory.dateTime)
                                    if (record != null) {
                                        historyData.record = record
                                        record.values.forEach(function(value){
                                            const recordValue = value.value.find((v)=>v.agrichemicalNo == chemical.agrichemicalNo)
                                            if (recordValue != null) {
                                                historyData.dilution = recordValue.dilution
                                                historyData.prevatication = recordValue.prevatication
                                            }
                                        })
                                    }
                                }
                            })
                        }
                    }
                }

                this.maxUsedDateNum = Math.max(...self.list.map(m => m.histories.length))

                if (this.conditionItems.oderByUseNum) {
                    this.list.sort(function(x, y) {
                        if (x.histories.length > y.histories.length) {
                            return -1
                        }
                        if (x.histories.length < y.histories.length) {
                            return 1
                        }
                        if (x.agrichemical.agrichemicalNo > y.agrichemical.agrichemicalNo) {
                            return 1
                        }
                        if (x.agrichemical.agrichemicalNo < y.agrichemical.agrichemicalNo) {
                            return -1
                        }
                        return 0
                    })
                }
            },
            /**
             * このダイアログを表示
             */
            show: function (targetPlace) {

                this.targetPlace = targetPlace
                this.agrichemical = this.$store.getters["managementItems/agrichemicals"].find((v)=>v.body.target == targetPlace.body.managementAgrichemical.target)

                const currentDateTime = new Date()

                this.conditionItems.year = currentDateTime.getFullYear()
                this.conditionItems.month = null
                this.conditionItems.oderByUseNum = true

                this.maxYear = this.conditionItems.year

                this.refresh()

                this.isView = true
            }
        }
    }
</script>
